import React from 'react'
import { styled } from 'styled-components'
import * as domain from '@packages/domain'
import { Prices } from '../../types'
import { PriceDisplay } from '../PriceDisplay'

interface OrderSummaryProps {
  paymentType: domain.PaymentType.Type
  prices: Prices
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
`

const Title = styled.h4`
  color: var(--bs-white);
  margin-bottom: 1rem;
  font-size: 1.125rem;
  font-weight: 600;
`

const SummaryLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--bs-white);
  font-size: 0.95rem;

  &.total {
    font-weight: 600;
    font-size: 1.1rem;
    padding-top: 0.5rem;
    border-top: 2px solid rgba(255, 255, 255, 0.3);
  }
`

const Label = styled.span`
  font-weight: 500;
`

const Amount = styled.span`
  font-weight: 600;
  color: var(--bs-light);
`

const PriceDisplayWithTax = styled(PriceDisplay)`
  text-align: end;
`

export const OrderSummary: React.FC<OrderSummaryProps> = ({ paymentType, prices }) => {
  return (
    <Container>
      <Title>Zusammenfassung Ihrer Bestellung</Title>

      {paymentType === 'partial' ? (
        <>
          <SummaryLine>
            <Label>Gesamtbetrag:</Label>
            <Amount>€ {prices.full.label}</Amount>
          </SummaryLine>
          <SummaryLine>
            <Label>Anzahlung:</Label>
            <Amount>€ {prices.partial.label}</Amount>
          </SummaryLine>
          <SummaryLine>
            <Label>Restzahlung (vor Ort):</Label>
            <Amount>
              €&nbsp;
              {(prices.full.value - prices.partial.value).toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </Amount>
          </SummaryLine>
          <SummaryLine className="total">
            <Label>Zahlbetrag:</Label>
            <PriceDisplayWithTax totalPrice={prices.partial.value} />
          </SummaryLine>
        </>
      ) : (
        <>
          <SummaryLine>
            <Label>Gesamtbetrag:</Label>
            <Amount>€ {prices.full.label}</Amount>
          </SummaryLine>
          <SummaryLine>
            <Label>Abzgl. {window.htcConfig.payment.skonto_percentage}% Skonto:</Label>
            <Amount>
              -&nbsp;€&nbsp;
              {(prices.full.value - prices.skonto.value).toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </Amount>
          </SummaryLine>
          <SummaryLine className="total">
            <Label>Zahlbetrag:</Label>
            <PriceDisplayWithTax totalPrice={prices.skonto.value} />
          </SummaryLine>
        </>
      )}
    </Container>
  )
}
